module.exports = __webpack_public_path__ + "img/wyjf.f5bfdc9a.png";